<script setup lang="ts">
import { Bell } from '@lucide/vue'

const props = defineProps<{ open: boolean }>()
const analytics = useAnalytics()
const emit = defineEmits<{ toggle: []; close: [] }>()
const notifications = useNotifications()
const trigger = ref<{ element?: HTMLButtonElement }>()
const menuId = useId()
onMounted(() => {
  void notifications.refresh(10)
})
async function select(item: (typeof notifications.items.value)[number]) {
  if (!item.readAt) await notifications.read(item.id, false)
  analytics.trackEvent('notification_action', {
    action: 'open',
    category: item.category,
    severity: item.severity,
    has_action: Boolean(item.actionUrl),
  })
  emit('close')
  if (item.actionUrl) {
    analytics.setNavigationSource('notification')
    await navigateTo(item.actionUrl)
  }
}
watch(
  () => props.open,
  (open) =>
    analytics.trackEvent('notification_action', { action: open ? 'bell_open' : 'bell_close' }),
)
</script>

<template>
  <div class="notification-bell">
    <UiIconButton
      ref="trigger"
      variant="chrome"
      :aria-controls="menuId"
      class="notification-bell-button"
      type="button"
      :aria-expanded="open"
      aria-haspopup="dialog"
      aria-label="Ouvrir les notifications"
      @click.stop="emit('toggle')"
    >
      <Bell :size="19" /><span
        v-if="notifications.unreadCount.value"
        class="notification-badge"
        :aria-label="`${notifications.unreadCount.value} notification(s) non lue(s)`"
        >{{ notifications.unreadCount.value > 99 ? '99+' : notifications.unreadCount.value }}</span
      ></UiIconButton
    ><UiPopover
      :id="menuId"
      :open="open"
      :anchor="trigger?.element"
      label="Notifications"
      :width="400"
      class="notification-popover analytics-sensitive"
      @close="emit('close')"
      ><NotificationsNotificationDropdown
        :notifications="notifications.items.value"
        :pending="notifications.pending.value"
        @open="select"
        @read-all="notifications.readAll"
    /></UiPopover>
  </div>
</template>
